import type { AnchorNavigationBarItem } from "~~/app/types/AnchorNavigationBarItem";
import { type Elements, type IContentItem } from '@kontent-ai/delivery-sdk'

export const useAnchorNavBar = () => {
    const navBarState = useState<AnchorNavigationBarItem[]>('navBarState', () => []);
    const AnchorNavBarOrder = useState<string[]>('AnchorNavBarOrder', () => []);

    const addItem = (shouldAdd: Elements.MultipleChoiceElement, text: string, id: string, codename: string) => {

        if (multipleChoiceToBoolean(shouldAdd)) {
            navBarState.value.push({ text: text, link: `#${id}`, index: AnchorNavBarOrder.value.indexOf(codename) });
        }
    }

    const getBlockIndex = (codename:string) => {
        return AnchorNavBarOrder.value.indexOf(codename);
    }
    const registerItem = (items: string[]) => {
        AnchorNavBarOrder.value.push(...items);
    }

    const reset = () => {
        navBarState.value = [];
        AnchorNavBarOrder.value = [];
    }
    return {
        addItem,
        registerItem,
        reset,
        getBlockIndex
    }
}


